<template>
  <table>
    <tr class="row">
      <td>id</td>
      <td>
        <a
          :href="'/node/edit/' + id"
          target="_blank"
        >{{ id }}</a>
      </td>
    </tr>
    <tr
      v-for="row in entries"
      :key="row[0]"
      class="row"
    >
      <td>{{ row[0] }}</td>
      <td>{{ row[1] }}</td>
    </tr>
  </table>
</template>
<script>
export default {
    name: "MapInfo",
    props: { marker: { type: Object, required: true } },
    data() {
        return {
            entries: [],
            id: ""
        };
    },
    watch: {
        marker: "parseInfo"
    },
    methods: {
        parseInfo() {
            if (this.$props.marker) {
              this.id = this.$props.marker.id;
              this.entries = Object.entries(this.$props.marker).filter(([key]) => key !== "id");
            }
        }
    }
};
</script>
<style scoped>
    a {
        text-decoration: underline;
    }
</style>
